/* prettier-ignore */

import { Component, ViewChild, ViewEncapsulation, Input, model, Output, EventEmitter } from '@angular/core';
import { DateAdapter } from '@angular/material/core';
import { DateRange, DefaultMatCalendarRangeStrategy, MatCalendar, MatRangeDateSelectionModel } from '@angular/material/datepicker';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { NewCustomRouteService } from 'src/app/pages/new-custom-route/new-custom-route.service';
import { ToolsService } from 'src/app/services/tools.service';
import dayjs from 'dayjs';

@Component({
    selector: 'cicerone-register-step-calendar',
    templateUrl: './step-calendar.component.html',
    styleUrls: ['./step-calendar.component.scss'],
    encapsulation: ViewEncapsulation.None,
})

export class RegistersCalendarComponent {
    @Output() public calendarDataEmitter: EventEmitter<any> = new EventEmitter<any>();
    @Input() registerStandalone?: boolean = false;
    @ViewChild('calendar') calendar: MatCalendar<Date> | undefined;
    selectedDateRange: DateRange<Date> | undefined;
    minDate: Date | undefined;
    private langSubscription: any;
    
    public selected = model<Date>(new Date());
    minutoEntrada: number = 0;
    minutoSalida: number = 0;
    dateRange: any;
    rangeTime = { lower: 6, upper: 23 };
    hours: any;
    minutes: any;
    horaEntrada: any;
    horaSalida: any;
    checkCalendar: any;
    route$: any;
    calendarTest:any


    constructor(
        public translate: TranslateService, 
        public route: ActivatedRoute, 
        private dateAdapter: DateAdapter<Date>, 
        private routeService: NewCustomRouteService,
        private readonly selectionModel: MatRangeDateSelectionModel<Date>, 
        private readonly selectionStrategy: DefaultMatCalendarRangeStrategy<Date>, 
        private tools: ToolsService
    ) {
        this.initSelectTime();
        this.horaEntrada = '09:00';
        this.horaSalida = 21;
        this.dateAdapter.getFirstDayOfWeek = () => 1; 
        this.dateAdapter.setLocale(this.translate.currentLang);
        this.minDate = this.dateAdapter.today();
        this.selectedDateRange = new DateRange<Date>(this.dateAdapter.today(), this.dateAdapter.today());
    }

    ngOnInit(){
        this.langSubscription = this.translate.onLangChange.subscribe(() => { 
            this.dateAdapter.setLocale(this.translate.currentLang);
        });
    }

    initSelectTime() {
        this.hours = Array.from({ length: 15 }, (_, i) => {
            if (i === 0) return '09:00'
            return `${i + 9}:00`
        }); 
        this.minutes = Array.from({ length: 60 }, (_, i) => i);
    }

    rangeChanged(selectedDate: Date) {
        const selection = this.selectionModel.selection;
        const newSelection = this.selectionStrategy.selectionFinished(selectedDate, selection);
    
        this.selectionModel.updateSelection(newSelection, this);
        this.selectedDateRange = new DateRange<Date>(newSelection.start, newSelection.end);

        const dateRange = {
            from: this.selectedDateRange.start,
            end: this.selectedDateRange.end ?? this.selectedDateRange.start
        }

        this.routeService.routeConfig = {
            ...this.routeService.routeConfig, 
            startDate: dayjs(dateRange.from), 
            endDate: dayjs(dateRange.end)
        };

        this.emitData(dateRange)
    }

    onStartTimeChange(event){
        const selectedHour = event.detail.value;
        this.routeService.routeConfig = {
            ...this.routeService.routeConfig, 
            startHourFirstDay: dayjs(selectedHour, 'HH:mm')
        };
    }

    emitData(dateRange){
        const dateRangeFormatted = {
            startDate: dayjs(dateRange.from).format('YYYY-M-DD'), 
            endDate: dayjs(dateRange.end).format('YYYY-M-DD'), 
        }
        this.calendarDataEmitter.emit(dateRangeFormatted);
    }

    ngOnDestroy(){
        if(this.langSubscription) 
          this.langSubscription.unsubscribe()
    
      }
}